import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_85m6bbbiw6: FaireBrandEntity = {
  token: "b_85m6bbbiw6",
  type: "brand",
  name: "Natural Amor LLC",
  avatarUrl:
    "https://cdn.faire.com/fastly/fb7ac7bf24b14c7673e7964d14d96b5296394802c65f3cf4f0e8e0f446609e42.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/b4b294222f4b9d35d86156d9c2f73edb7ff14a38d53c94afc619b84aad79f4b7.png",
  logoUrl:
    "https://cdn.faire.com/fastly/fb7ac7bf24b14c7673e7964d14d96b5296394802c65f3cf4f0e8e0f446609e42.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/b4b294222f4b9d35d86156d9c2f73edb7ff14a38d53c94afc619b84aad79f4b7.png",
  location: "Covina, CA, USA",
  minimumOrderDollars: 150,
  rating: 5,
  reviewCount: 50,
  isTopShop: true,
  isInsider: true,
  description:
    "Women-owned natural skincare company based in sunny Los Angles to generate natural products that nourish the skin gently. We focus on being waste-free, cruelty-free, and eco-friendly. \nOur handmade soap are made with natural ingredients in small batches to ensure the highest quality. All our soap bars are palm Oil free for environmental consideration. We use cold process method to best preserve the nutrients and effectiveness of those gorgeous oils. Scented with natural essential oil.\nWe have over 4000 reviews on our Etsy Store and our average rating is 4.9. We have a lot of return customers who love our natural, cruelty free handmade skincare. We are looking forward to working with you!",
  meta: {
    source: "api",
    importedAt: "2026-07-23T05:56:04.230Z",
    importedBy: "entity-db-cli",
  },
};
